import { Injectable } from '@angular/core';

@Injectable({
	providedIn: 'root',
})
export class NotificationService {
	checkNotificationSupport(): boolean {
		return 'Notification' in window;
	}

	requestPermission(): void {
		if (!this.checkNotificationSupport()) return;

		Notification.requestPermission()
	}

	showNotification(title: string, options?: NotificationOptions): void {
		if (Notification.permission === 'granted') {
			const notification = new Notification(title, options);

			notification.onclick = () => {
				window.focus();
			};
		}
	}
}
